export const RELSIFY_URL = (state) => {
  return state.RELSIFY_URL;
};
export const DASHBOARD_URL = (state) => {
  return state.DASHBOARD_URL;
};

export const RequestId = () => {
  let text = "";
  let possible =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (let i = 0; i < 10; i++)
    text += possible.charAt(Math.floor(Math.random() * possible.length));

  return text;
};

export const user = (state) => {
  return state.user;
};

export const isLoggedIn = (state) => {
  return !!state.token;
  // return state.isUserLoggedIn;
};

export const showMobileMenu = (state) => {
  return state.showMobileMenu;
};

export const token = (state) => {
  return state.token;
};

export const currentPageName = (state) => {
  return state.currentPageName;
};

export const countries = (state) => {
  return state.countries;
};

export const projects = (state) => {
  return state.projects;
};

export const projectCategory = (state) => {
  return state.projectCategory;
};

export const loginModal = (state) => {
  return state.loginModal;
};

export const pageLoading = (state) => {
  return state.pageLoading;
};

//  modal Loading
export const modalLoading = (state) => {
  return state.modalLoading;
};

// alert popUp
export const alertpopUp = (state) => {
  return state.alertpopUp;
};

// Verify pincode modal
export const verifyPinCodeModal = (state) => {
  return state.verifyPinCodeModal;
};

export const relsifyLogo = () => {
  return require('@/assets/relsify_logo.svg');
};
// export const relsifyLogo = () => {
export const faqs = (state) => {
  return state.faqs;
};
